var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.22rem",
    height: "2.22rem",
    viewBox: "0 0 40 40",
    alt: "Learn More Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.92,7.4a11.8,11.8,0,1,0,11.8,11.8A11.82,11.82,0,0,0,19.92,7.4Zm0,21.5a9.7,9.7,0,1,1,9.7-9.7A9.71,9.71,0,0,1,19.92,28.9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.72,
    y: 24,
    width: 2.4,
    height: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.52,15.8a4.78,4.78,0,0,0-5.7-3.5,4.72,4.72,0,0,0-3.6,4.6h2.4a2.41,2.41,0,0,1,4.8.4,2.48,2.48,0,0,1-2.5,2,1.11,1.11,0,0,0-1.1,1.1h0v2.5h2.4V21.6A5,5,0,0,0,24.52,15.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/HelpCircle.f47a64ad.svg";
export { ForwardRef as ReactComponent };